import React, { Component } from 'react';
import './style.scss';

export default class History extends Component {
    render() {
        return (
            <section className="history-container">
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item">
                        <div className="text-section">
                            <div className="title">
                                <h1>1981</h1>
                                <p>JD Sports began with its first store in Bury, Greater Manchester.</p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/1981.jpg"
                                alt="JD Sports shop front from 1981"
                                className="image"
                            />
                        </div>
                    </div>
                    <div className="history-item">
                        <div className="text-section">
                            <div className="title">
                                <h1>1989</h1>
                                <p>JD Sports opened its first store on Oxford Street, London.</p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/1989.jpg"
                                alt="Oxford Street, London street sign"
                                className="image"
                            />
                        </div>
                    </div>
                    <div className="start"></div>
                    <div className="connector right"></div>
                </div>
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item right-to-left">
                        <div className="text-section on-left">
                            <div className="title">
                                <h1>2005</h1>
                                <p>57.5% of JD Sports Fashion Plc was bought by the Pentland Group.</p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/img2005.png"
                                alt="Pentland Group logo"
                                className="image"
                                style={{ height: 'auto' }}
                            />
                        </div>
                    </div>
                    <div className="history-item">
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/1996.jpg"
                                alt="London Stock Exchange logo"
                                className="image"
                            />
                        </div>
                        <div className="text-section">
                            <div className="title">
                                <h1>1996</h1>
                                <p>JD Sports Fashion Plc was listed on the London Stock Exchange.</p>
                            </div>
                        </div>
                    </div>
                    <div className="connector left"></div>
                </div>
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item with-blank-image">
                        <div className="image-section"></div>
                        <div className="text-section">
                            <div className="title">
                                <h1>2009</h1>
                                <p>
                                    JD Sports Fashion Plc acquired Chausport, a French sports retailer; the Group's
                                    first international presence & entry into Europe.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="history-item">
                        <div className="text-section">
                            <div className="title">
                                <h1>2010</h1>
                                <p>JD Sports opened its first JD in Lille, France; our first store in Europe.</p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2010.jpg"
                                alt="JD Sports shop front from 2009"
                                className="image"
                            />
                        </div>
                    </div>
                    <div className="connector right"></div>
                </div>
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item right-to-left">
                        <div className="text-section on-left">
                            <div className="title">
                                <h1>2012</h1>
                                <p>
                                    The JD Group expanded into the Outdoor market with Blacks and Millets joining the
                                    Group.
                                </p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2012.jpg"
                                alt="London Stock Exchange logo"
                                className="image"
                            />
                        </div>
                    </div>
                    <div className="history-item">
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2011.jpg"
                                alt="London Stock Exchange logo"
                                className="image"
                            />
                        </div>
                        <div className="text-section ">
                            <div className="title">
                                <h1>2011</h1>
                                <p>
                                    The JD Group acquired Sprinter, a leading Spanish sports retailer, specialising in
                                    footwear, apparel & equipment; the Group's first entry into Spain.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="connector left"></div>
                </div>
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item">
                        <div className="text-section">
                            <div className="title">
                                <h1 className="through-line">2016</h1>
                                <p>
                                    The JD Group launched its first JD Sports store in Malaysia; the Group's first entry
                                    into Asia Pacific. JD now has stores in Australia, Singapore &amp; Thailand.
                                </p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2016.jpg"
                                alt="JD Sports launches new store in Malaysia"
                                className="image"
                            />
                        </div>
                    </div>
                    <div className="history-item" style={{ paddingLeft: '3em' }}>
                        <div className="text-section">
                            <div className="title">
                                <h1>&nbsp;</h1>
                                <p>
                                    The JD Group acquired Go Outdoors, the UK's 'destination' for everything outdoors.
                                </p>
                                <p>
                                    The JD Group also opened its first gym as part of JD Gyms; an affordable yet stylish
                                    gym concept.
                                </p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2017.jpg"
                                alt="JD Sports acquired Go Outdoors"
                                className="image"
                            />
                        </div>
                    </div>
                    <div className="connector right"></div>
                </div>
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item" style={{ justifyContent: 'flex-start', width: '25%' }}>
                        {/*<div className="image-section"></div>*/}
                        <div className="text-section">
                            <div className="title">
                                <h1>2019</h1>
                                <p>The JD Group was promoted to the FTSE100 list of largest businesses in the UK.</p>
                            </div>
                        </div>
                    </div>
                    <div className="history-item" style={{ width: '45%' }}>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2018.jpg"
                                alt="JD Chicago store"
                                className="image"
                            />
                        </div>
                        <div className="text-section">
                            <div className="title">
                                <h1>2018</h1>
                                <p>
                                    The JD Group acquired Finish Line in the United States, a sports fashion retailer
                                    with a store presence across 44 states. JD Sports opened its first 5 JD stores in
                                    the USA: Chicago, Houston, Columbus, Washington and Indianapolis.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="history-item" style={{ width: '30%' }}>
                        <div className="text-section">
                            <div className="title">
                                <h1>2017</h1>
                                <p>The JD Group acquired Hot-T, a South Korean retailer of sports branded footwear.</p>
                            </div>
                        </div>
                    </div>
                    <div className="connector left"></div>
                </div>
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item">
                        <div className="text-section">
                            <div className="title">
                                <h1 className="through-line">2020</h1>
                                <p>
                                    JD opened its first store in Times Square, New York, USA; JD’s first flagship in the
                                    U.S.
                                </p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2020-1.jpg"
                                alt="JD Times Square Store"
                                className="image"
                            />
                        </div>
                    </div>
                    <div className="history-item" style={{ paddingLeft: '3em' }}>
                        <div className="text-section">
                            <div className="title">
                                <h1>&nbsp;</h1>
                                <p>
                                    The JD Group acquired Shoe Palace, a retailer of branded sports footwear and apparel
                                    based on the West Coast of the U.S. On acquisition, Shoe Palace had 167 stores, most
                                    of which are in California and a strong connection with Hispanic and Latino
                                    communities.
                                </p>
                            </div>
                        </div>
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/2020-2.jpeg"
                                alt="JD Shoe Palace"
                                className="image"
                            />
                        </div>
                    </div>

                    <div className="connector right"></div>
                </div>
                <div className="history-row">
                    <div className="border"></div>
                    <div className="history-item box">
                        <p>
                            The JD Group now has over 3,300 stores in 29 territories, including over 890 JD stores, as
                            we continue to expand.
                        </p>
                    </div>
                    <div className="history-item">
                        <div className="image-section">
                            <img
                                src="https://files.jdplc.com/images/history/dtlr.png"
                                alt="DTLR store interior"
                                className="image"
                            />
                        </div>
                        <div className="text-section">
                            <div className="title">
                                <h1>2021</h1>
                                <p>
                                    The JD Group acquired DTLR, a retailer of athletic footwear and apparel streetwear
                                    based in Maryland, United States. On acquisition, DTLR had 247 stores across 19
                                    states, principally in the North and East of the United States.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
